"use client";

import { c as _c } from "react/compiler-runtime";
import { AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import type { PlpFilterGroupConfig } from "@/lib/contentful/filterGroups";
import { PlpRefinementListFilter } from "./PlpRefinementListFilter";
interface Props {
  group: PlpFilterGroupConfig;
  isLast?: boolean;
}
export function PlpRefinementGroup(t0) {
  const $ = _c(12);
  const {
    group,
    isLast
  } = t0;
  const t1 = isLast ? "border-b-0" : "border-border";
  const t2 = `plp-filter-group-${group.slug}`;
  let t3;
  if ($[0] !== group.label) {
    t3 = <AccordionTrigger className="text-2xl font-semibold hover:no-underline">{group.label}</AccordionTrigger>;
    $[0] = group.label;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== group.dynamic || $[3] !== group.slug || $[4] !== group.values) {
    t4 = <AccordionContent><PlpRefinementListFilter attribute={group.slug} values={group.values} dynamic={group.dynamic} /></AccordionContent>;
    $[2] = group.dynamic;
    $[3] = group.slug;
    $[4] = group.values;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== group.slug || $[7] !== t1 || $[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <AccordionItem value={group.slug} className={t1} data-testid={t2}>{t3}{t4}</AccordionItem>;
    $[6] = group.slug;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}